import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { selectIsAuthenticated, selectIsLoading, selectIsProfileLoaded } from '../../store/slices/authSlice';
import GlobalLoader from '../shared/GlobalLoader';

function ProtectedRoute({ children }) {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const isLoading = useSelector(selectIsLoading);
  const isProfileLoaded = useSelector(selectIsProfileLoaded);
  const location = useLocation();

  // Show loader while:
  // 1. Auth state is being determined (isLoading)
  // 2. User is authenticated but profile hasn't loaded yet
  // The AuthProvider will keep retrying until profile is loaded
  if (isLoading || (isAuthenticated && !isProfileLoaded)) {
    return <GlobalLoader message="טוען..." />;
  }

  if (!isAuthenticated) {
    // Redirect to login page but save the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute;

